import { ReactSVG } from "react-svg";

import { UserRow } from "services/api/users/types";
import UserCell from "ui/components/Table/TableSearch/components/Cells/UserCell";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const OFFICE_USER_COLUMNS = (
  handleDeleteClick: (event: React.MouseEvent<HTMLDivElement>, id: string) => void
): Column[] => [
  {
    title: "Korisnik",
    field: "firstName",
    type: ColumnTypes.custom,
    render: (row: UserRow) => (
      <UserCell
        fullName={[row.firstName, row.lastName].filter(Boolean).join(" ")}
        userId={row.id}
        email={row.email}
        imageUrl={row.avatar}
      />
    ),
  },
  {
    title: "Email",
    field: "email",
    type: ColumnTypes.custom,
    render: (row: UserRow) => <span className="text-sm text-slate-900">{row.email}</span>,
  },
  {
    title: "Telefon",
    field: "mobilePhoneNumber",
    type: ColumnTypes.custom,
    render: (row: UserRow) => (
      <div className="text-sm text-slate-900 whitespace-nowrap">
        {row.mobilePhoneNumber || row.phoneNumber || (
          <span className="text-slate-400">Bez broja</span>
        )}
      </div>
    ),
  },
  {
    title: "Uloge",
    field: "roles",
    type: ColumnTypes.custom,
    render: (row: UserRow) =>
      row.roles?.length > 0 ? (
        <span className="text-sm text-slate-500">
          {row.roles.map((role) => role.name).join(", ")}
        </span>
      ) : (
        <span className="text-sm text-slate-400">Bez uloge</span>
      ),
  },
  {
    title: "",
    field: "",
    type: ColumnTypes.custom,
    render: (row: UserRow) => (
      <div
        onClick={(e) => handleDeleteClick(e, row.id)}
        className="flex justify-end items-center h-[30px] cursor-pointer"
      >
        <ReactSVG src="/media/icons/trash.svg" className="w-4 h-4 stroke-[#bd0000]" />
      </div>
    ),
  },
];
